//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { Opaque } from '@utils/opaque';

type PostableId = Opaque<number, 'PostableId'>;

function PostableIdFactory(postableId: number) {
  return postableId as PostableId;
}

const PostableId = Object.assign(
  PostableIdFactory,
  {
    fromString(postableId: string) {
      return PostableIdFactory(parseInt(postableId, 10));
    },
  },
);

export default PostableId;
